var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-contract-contain"},[_c('Navbar',{attrs:{"title":"我的合同"}}),_c('div',{staticClass:"inner-contract"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seal-img"},[_c('img',{attrs:{"src":require("./asset/img/seal-img.png"),"alt":""}})])
}]

export { render, staticRenderFns }